module.exports = __webpack_public_path__ + "img/toogle.fcf60570.svg";